import { AfterViewInit, Component, ElementRef, HostListener, Input, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CourseCatalogPostingStream } from 'app/library/course-catalog-landing-page/models/course-catalog-posting-stream.model';
import { CourseCatalogService } from 'app/library/course-catalog/services/course-catalog.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { GeneralAnalyticsService } from 'app/services/general-analytics.service';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { CatalogPostingsDialogComponent } from '../../dialogs/catalog-postings-dialog/catalog-postings-dialog.component';
@Component({
    selector: 'app-catalog-postings-swipper',
    templateUrl: './catalog-postings-swiper.component.html',
    styleUrls: ['./catalog-postings-swiper.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CatalogPostingsSwipperComponent extends UnsubscribeOnDestroy implements AfterViewInit {
    @ViewChild('nextBtn', { static: false }) nextBtn!: ElementRef;
    @ViewChild('prevBtn', { static: false }) prevBtn!: ElementRef;
    @ViewChildren('postingsRef') postingsRef!: QueryList<ElementRef>;
    @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef;
    isPostingVisible: boolean = false;

    public swiperConfig: SwiperOptions = {
        a11y: { enabled: true },
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 8,
        keyboard: false,
        mousewheel: false,
        scrollbar: false,
        pagination: false,
        allowTouchMove: false,
        slideVisibleClass: 'swiper-slide-visible',
        slideActiveClass: 'swiper-slide-active',
        loop: false,
        watchSlidesProgress: true,
        navigation: {
            prevEl: '.postings-swiper-button-prev',
            nextEl: '.postings-swiper-button-next',
        },
        breakpoints: {
            // when window width is >= 1280px
            1280: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    };

    isMobileView: boolean;
    currentSlideWrapper: HTMLElement;

    // If we show the component inside dialog, we treat it as desktop view to show hover effects
    @Input()
    isInsideDialog: boolean = false;

    @HostListener('window:resize')
    getScreenSize(): void {
        // Align with Fuse gt-md / desktop layout (1280px): hover on laptops (incl. 1366), click on tablets
        const scrWidth = window.innerWidth;
        this.isMobileView = scrWidth < 1280;
    }

    onMouseEnter(postingResource: CourseCatalogPostingStream, event: MouseEvent) {
        // Show slide hover active data only for desktop view
        if (!this.isMobileView || !this.isInsideDialog) {
            const slideWrapper = event.currentTarget as HTMLElement;
            setTimeout(() => {
                if (this.currentSlideWrapper === slideWrapper) {
                    slideWrapper.classList.add('slide-hover-active');
                    this.sendPostingViewEvent('posting_clicked', postingResource);
                }
            }, 500);
        }
    }

    onMouseLeave(event: MouseEvent) {
        const slideWrapper = event.currentTarget as HTMLElement;
        slideWrapper.classList.remove('slide-hover-active');
        this.currentSlideWrapper = null;
    }

    onMouseMove(event: MouseEvent) {
        const slideWrapper = event.currentTarget as HTMLElement;
        this.currentSlideWrapper = slideWrapper;
    }

    @Input()
    featuredWidget: CourseCatalogPostingStream[];

    constructor(
        private _router: Router,
        private _matDialog: MatDialog,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        private _courseCatalogService: CourseCatalogService
    ) {
        super();
    }

    ngAfterViewInit(): void {
        this.swiperConfig.navigation = {
            prevEl: this.prevBtn.nativeElement,
            nextEl: this.nextBtn.nativeElement,
        };

        Object.assign(this.swiperEl.nativeElement, this.swiperConfig);
        this.swiperEl.nativeElement.initialize();

        const swiperContainer = this.swiperEl.nativeElement.shadowRoot.querySelector('.swiper') as HTMLElement;
        if (swiperContainer) {
            swiperContainer.style.overflow = 'visible';
        }

        this.getScreenSize();
    }

    openPostingUrl(postingResource: CourseCatalogPostingStream) {
        // Follow posting url on click only if it's not mobile view
        if (!this.isMobileView) {
            this.sendPostingViewEvent('posting_link_followed', postingResource);

            // If the url starts with the same domain as the custom domain (whole one, not just base domain) then open internally
            if (postingResource.url.includes(window.location.host)) {
                const relativePath = new URL(postingResource.url).pathname;

                if (postingResource.kind === 'course_category') {
                    const categoryId = relativePath.split('/').filter(Boolean).pop();
                    if (categoryId) {
                        this._courseCatalogService.setSelectedCategoryId(categoryId);
                    }
                }

                this._router.navigateByUrl(relativePath);
            } else {
                const currentPostUrl = postingResource.url;
                window.open(currentPostUrl, '_blank');
            }
        }
    }

    openPostInDialog(index: number, isFirst: boolean, isLast: boolean) {
        // Open posting in dialog only for mobile view
        if (this.isMobileView) {
            const dialogRef = this._matDialog.open(CatalogPostingsDialogComponent, {
                width: '656px',
            });

            dialogRef.componentInstance.featuredWidget = this.featuredWidget;
            dialogRef.componentInstance.index = index;
            dialogRef.componentInstance.isFirst = isFirst;
            dialogRef.componentInstance.isLast = isLast;
        }
    }

    async sendPostingViewEvent(eventName: string, postingResource: CourseCatalogPostingStream) {
        /*  if (this._router.url === '/catalog/category') {
            this._locationBasedAnalyticsService.createPostingEvent(
                eventName,
                postingResource.id,
                postingResource.postingType.id,
                postingResource.translation.title,
                null,
                this.featuredWidget.id,
                this.featuredWidget.translation.title
            );
        } */
    }
}
